module.exports = __webpack_public_path__ + "img/evaluate_bad.fc02025c.svg";